export default __webpack_public_path__ + "static/media/AvenirLTStd-Roman.0bfb049d.otf";